import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DataCollectorService } from '../data_collector_services/data_collector_service.service';
import { HttpClient } from '@angular/common/http';
import { LocalStorageService } from '../localstorage.service';
import _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class CustomersService {
    get customerUrl(): string{
        return `${this.dataCollectorService.baseurl()}/customers/`;
    }
    get paymentsUrl(): string{
        return `${this.dataCollectorService.baseurl()}/payments/customers/`;
    }
    get paymentProviderUrl(): string{
        return `${this.dataCollectorService.baseurl()}/payments/provider`;
    }
    get customerAPIUrls(): any{
        return {
            propertyUrl: `${this.dataCollectorService.baseurl()}/property`,
            serviceContractUrl: `${this.dataCollectorService.baseurl()}/service_contract`,
            assetsUrl: `${this.dataCollectorService.baseurl()}/assets`,
            recurringJobsUrl: `${this.dataCollectorService.baseurl()}/recurring_jobs`,
            transactionsUrl: `${this.dataCollectorService.baseurl()}/payments/transactions`,
            dataUrl : `${this.dataCollectorService.baseurl()}/v2/customers/filter`,
            columnUrl: `${this.dataCollectorService.baseurl()}/v2/customers/meta`,
            filterUrl: `${this.dataCollectorService.baseurl()}/v2/customers/meta/filter`,
            bulkActionUrl: `${this.customerUrl}bulk_action`,
            invoiceUrl: `${this.dataCollectorService.baseurl()}/invoice`,
            estimateUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            sendsmsUrl: `${this.dataCollectorService.baseurl()}/estimate`,
            mergeCustomerUrl: `${this.dataCollectorService.baseurl()}/customers/merge`,
            outboundUrl: `${this.dataCollectorService.baseurl()}/outbound_logs`,
            newCustomer: `${this.dataCollectorService.baseurl()}/customers_new`,
            projectUrl: `${this.dataCollectorService.baseurl()}/projects`,
            requestUrl: `${this.dataCollectorService.baseurl()}/request`,
            creditHistoryUrl: `${this.dataCollectorService.baseurl()}/accounting/credit_notes`,
            creditNoteHistoryUrl: `${this.dataCollectorService.baseurl()}/accounting/credit_history`,
            creditExportUrl: `${this.dataCollectorService.baseurl()}/reports/customer/credit_history`

        };
    }

    customerDetailsLoaded: Subject<boolean> = new Subject<boolean>();
    currentCustomerDetails = new BehaviorSubject<any>(null);
    selectedOrganizationPropertyPickerFilterValue = new BehaviorSubject<any>(null);

    constructor(private dataCollectorService: DataCollectorService, private http: HttpClient,private _localStorageService: LocalStorageService) {
        this.customerDetailsLoaded.next(false);
     }


    activationURl(customerId: string): string{
        return `${this.customerUrl}${customerId}/activation`;
      }
    getCustomerUrl(customerId: string): string {
        return `${this.customerUrl}${customerId}`;
    }

    getCustomerCatgeory(): string {
        return `${this.customerUrl}category`;
    }

    getPaymentCardsUrl(customerId: string): string {
        return `${this.paymentsUrl}${customerId}/cards`;
    }

    getCustomerNotesUrl(customerId: string): string {
        return `${this.customerUrl}${customerId}/note`;
    }
    deleteURL(customerId: string): string{
        return `${this.customerUrl}${customerId}`;
    }
    getPaymentCards(customerId: string): any{
        const paymentURL= `${this.paymentsUrl}${customerId}/cards`;
        return this.dataCollectorService.getData(paymentURL);
    }

    getSendSmsEmailUrl(customerId: string): string{
        const paymentURL= `${this.getCustomerUrl(customerId)}/send`;
        return paymentURL;
    }

    getOutboundLogDetailsUrl(logId): string{
        return `${this.dataCollectorService.baseurl()}/outbound_logs/${logId}`;
    }

    getBillingFrequency(): string {
        return this.customerUrl + 'billing_frequency';
    }

    getPaymentTerms(): string {
        return this.dataCollectorService.baseurl() + '/invoices/payment_terms';
    }

    getTaxGroups(): string {
        return this.dataCollectorService.baseurl() + '/invoice_estimate/tax_groups';
    }

    getPriceList(): string {
        return this.dataCollectorService.baseurl() + '/products/pricelist';
    }

    getCardIntentUrl(customerUID): string{
        return `${this.paymentsUrl}${customerUID}/card_intent`;
    }

    getAccountsUrl(customerUID: string): string{
        return `${this.dataCollectorService.baseurl()}/customers/${customerUID}/accounts`;
    }

    getTaxEntitiesUrl(): string {
        return this.dataCollectorService.baseurl() + '/taxes/entity_use_codes';
    }
    performBulkAction(payload): Observable<any>{
        const url = `${this.customerUrl}bulk_action`;
        return this.dataCollectorService.postData(url,payload);
      }
    getPropertyAssociationUrl(customerUID: string): string {
        return `${this.dataCollectorService.baseurl()}/customers/${customerUID}/associations`;
    }

    getCreditHistory(payload): Observable<any> {
       return this.dataCollectorService.getData(this.customerAPIUrls.creditHistoryUrl,payload)
    }
    getCreditHistoryDetails(payload): Observable<any> {
        let url = `${this.customerAPIUrls.creditHistoryUrl}/${payload}`
        return this.dataCollectorService.getData(url)
     }

    postCreditHistory(payload): Observable<any> {
        return this.dataCollectorService.postData(this.customerAPIUrls.creditHistoryUrl,payload)
    }

    putCreditHistory(creditUid,payload): Observable<any> {
        let url = `${this.customerAPIUrls.creditHistoryUrl}/${creditUid}`
        return this.dataCollectorService.putData(url,payload)
    }

    deleteCreditHistory(payload): Observable<any> {
        let url = `${this.customerAPIUrls.creditHistoryUrl}/${payload?.credit_note_uid}`
        if (payload?.remarks) {
            url += `?remarks=${payload.remarks}`;
        }
        return this.dataCollectorService.deleteData(url)
    }

    getCreditNoteHistory(payload): Observable<any> {
        let url = `${this.customerAPIUrls.creditNoteHistoryUrl}`
        return this.dataCollectorService.getData(url, payload)
    }

    exportCredits(payload): Observable<any> {
        return this.dataCollectorService.postData(this.customerAPIUrls.creditExportUrl,payload,{ responseType: 'blob'});
    }

    hasPermission(key: string): boolean {
        const user = this._localStorageService.getLocalStorage('user');
        if (!user) {
            return false;
        }
        const permissions = _.map(this._localStorageService.getLocalStorage('user_permissions'), 'permissions');

        if (user?.access_role && permissions?.length === 0) {
            return false;
        }

        // If permissions is available, check if user has access
        const is_found = _.filter(permissions, (p: any) => String(p?.permission_key) === String(key));

        if (is_found && is_found.length > 0) {
            return true;
        }

        return false;

    }
    
}